import { fetchTamdaMediaSetting } from "@/services/tamdaMediaSetting"
import { TamdaMediaSettingData, TamdaMediaSettings } from "@/types/types"
import { create } from "zustand"

interface TamdaMediaSettingsState {
  settings: TamdaMediaSettings | null
  loading: boolean
  error: Error | null
  isFetching: boolean
  fetchSettings: () => Promise<void>
}

export const useTamdaMediaSettingsStore = create<TamdaMediaSettingsState>(set => ({
  settings: null,
  loading: false,
  error: null,
  isFetching: false,

  fetchSettings: async () => {
    const currentState = useTamdaMediaSettingsStore.getState()
    
    if (currentState.settings || currentState.isFetching) {
      return
    }

    try {
      set({ isFetching: true, loading: true, error: null })
      const apiData = await fetchTamdaMediaSetting()
      if (apiData?.attributes) {
        const attributes = apiData.attributes as TamdaMediaSettingData["attributes"]
        set({
          settings: {
            phone: attributes.phoneNumber || attributes.hotline,
            email: attributes.email,
            advertisingEmail: attributes.advertisingEmail,
            facebook: attributes.facebook,
            youtube: attributes.youtube,
            tagline: attributes.tagline,
          },
          loading: false,
          isFetching: false,
        })
      } else {
        set({ loading: false, isFetching: false })
      }
    } catch (error) {
      console.error("Failed to load tamda media settings:", error)
      set({
        error: error instanceof Error ? error : new Error("Unknown error"),
        loading: false,
        isFetching: false,
      })
    }
  },
}))

